import useMeetingsRefresh from "../../hooks/useMeetingsRefresh";
import RefreshMeetingsButton from "./RefreshMeetingsButton";
//final latest
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { AuthContext } from "../../context/AuthContext";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import campsite from "../../assets/images/campsite.png";
import park from "../../assets/images/park.png";
import { useNavigate } from "react-router-dom";
import summerSun from "../../assets/images/sun.png";
import summerCloudSet1 from "../../assets/images/clouds.png";
import summerCloudSet2 from "../../assets/images/clouds2.png";
import summerBirdSet1 from "../../assets/images/birds.png";
import summerBirdSet2 from "../../assets/images/birds.png";
import summerWaves from "../../assets/images/waves.png";
import NewSpace from "../../assets/images/NewSpace.png"
import winterHoliday from "../../assets/images/winterHoliday.png"
import Env from '../../runtimeEnv';
import axios from "axios";
import WarningBanner from '../WarningBanner';
import SessionFeedbackModal from "../SessionFeedbackModal";

function ClientTherapyRooms() {
  const navigate = useNavigate();
  const [enabledRoom, setEnabledRoom] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [roomsOnlineStatus, setRoomsOnlineStatus] = useState({});
  const [sessionStartTimes, setSessionStartTimes] = useState({});
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [meetingExists, setMeetingExists] = useState(false);
  const [showSessionFeedback, setShowSessionFeedback] = useState(false);
  const [feedbackEligibilityChecked, setFeedbackEligibilityChecked] = useState(false);
  const {
    currentNickname,
    setCurrentNickname,
    PlutonicuserID,
    loading,
    setLoading,
    
  } = useContext(AuthContext);

  useEffect(() => {
    if (loading || feedbackEligibilityChecked) return;
    setFeedbackEligibilityChecked(true);
    axios.post(
      `${Env.REACT_APP_PYTHON_API_URL}/api/feedback-prompt`,
      {},
      { withCredentials: true }
    ).then((response) => {
      if (response.data.show) setShowSessionFeedback(true);
    }).catch((error) => {
      console.warn("Unable to check session feedback eligibility:", error);
    });
  }, [feedbackEligibilityChecked, loading]);

  const { refreshMeetings, refreshing, refreshError } = useMeetingsRefresh(async (signal) => {
      const savedUserID =
        PlutonicuserID || localStorage.getItem("PlutonicuserID");
      const savedNickname =
        currentNickname || localStorage.getItem("currentNickname");

      if (savedNickname) {
        setCurrentNickname(savedNickname);
      }

      if (savedUserID) {
        try {
          const response = await axios.get(
            `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${savedUserID}`,
            { signal, params: { t: Date.now() } }
          );

          if (signal.aborted) return;
          if (response.data.length > 0) {
            const nowUTC = new Date();
            const gracePeriodBeforeMs = 15 * 60 * 1000;
            const gracePeriodAfterMs = 75 * 60 * 1000;
            const backToBackBufferMs = 20 * 60 * 1000;

            let hasEligibleMeeting = false;
            let latestUpcomingSession = null;

            const roomSessionsMap = response.data.reduce((acc, room) => {
              const roomId = room.meetingID.split(".")[0].replace("-therapy", "");
              const sessionTimeUTC = new Date(room.sessionTime);

              const formattedTimeEST =
                sessionTimeUTC.toLocaleString("en-US", {
                  timeZone: "America/New_York",
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }) + " EST";

              if (!acc[roomId]) acc[roomId] = [];

              acc[roomId].push({
                meetingID: room.meetingID,
                sessionStartTimeEST: formattedTimeEST,
                sessionStartTimeUTC: sessionTimeUTC.toISOString(),
                rawStartTime: sessionTimeUTC,
                online: room.online.some((s) => s === true),
                isAvailable: false,
                isUpcoming: false,
              });

              return acc;
            }, {});

            Object.keys(roomSessionsMap).forEach((roomId) => {
              const sessions = roomSessionsMap[roomId];
              sessions.sort(
                (a, b) =>
                  new Date(a.sessionStartTimeUTC) -
                  new Date(b.sessionStartTimeUTC)
              );

              for (let i = 0; i < sessions.length; i++) {
                const current = sessions[i];
                const next = sessions[i + 1];

                const currentStart = new Date(current.sessionStartTimeUTC);
                const timeUntilCurrent = currentStart - nowUTC;
                const timeSinceCurrent = nowUTC - currentStart;

                const isInGraceWindow =
                  (timeUntilCurrent <= gracePeriodBeforeMs &&
                    timeUntilCurrent >= 0) ||
                  (timeSinceCurrent >= 0 &&
                    timeSinceCurrent <= gracePeriodAfterMs);

                const isUpcoming =
                  timeUntilCurrent > 0 &&
                  timeUntilCurrent <= gracePeriodBeforeMs;
                let isSuppressed = false;

                if (next) {
                  const nextStart = new Date(next.sessionStartTimeUTC);
                  const timeUntilNext = nextStart - nowUTC;
                  const allowSuppression =
                    timeUntilNext <= backToBackBufferMs &&
                    timeUntilNext >= -15 * 60 * 1000;

                  if (allowSuppression) {
                    isSuppressed = true;
                    next.isUpcoming = true;
                  }
                }

                current.isAvailable = isInGraceWindow;
                current.isUpcoming = isUpcoming;
                current.isPrimary =
                  (isInGraceWindow || isUpcoming) && !isSuppressed;

                // if (current.isAvailable || current.isUpcoming) {
                //   hasEligibleMeeting = true;
                // }
                hasEligibleMeeting = true; // Mark as true if *any* session exists, not just active/upcoming

                if (
                  current.isPrimary &&
                  (!latestUpcomingSession ||
                    currentStart >
                      new Date(latestUpcomingSession.sessionStartTimeUTC))
                ) {
                  latestUpcomingSession = current;
                }
              }
            });

            const sessionStartTimesMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                const nextSession = sessions.find(
                  (session) => session.isAvailable || session.isUpcoming
                );
                if (nextSession) acc[roomId] = nextSession.sessionStartTimeEST;
                return acc;
              },
              {}
            );

            const onlineStatusMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                acc[roomId] = sessions.some((session) => session.online);
                return acc;
              },
              {}
            );

            setRoomsOnlineStatus(onlineStatusMap);
            setEnabledRoom(roomSessionsMap);
            setSessionStartTimes(sessionStartTimesMap);
            setMeetingExists(hasEligibleMeeting);
          } else {
            setEnabledRoom({});
            setRoomsOnlineStatus({});
            setSessionStartTimes({});
            setMeetingExists(false);
          }
        } catch (error) {
          if (!signal.aborted) setLoading(false);
          throw error;
        }
      }

      if (!signal.aborted) setLoading(false);
  }, PlutonicuserID);

  useEffect(() => {
    if (PlutonicuserID) {
      axios
        .get(
          `${Env.REACT_APP_PYTHON_API_URL}/api/get-selected-space/${PlutonicuserID}`
        )
        .then((res) => {
          const space = res.data.selectedSpace;
          if (space) {
            setSelectedSpace(space);
          } else {
            console.log("No space selected previously.");
          }
        })
        .catch((err) => console.error("Error fetching selected space:", err));
    }
  }, [PlutonicuserID]);

  // ✅ Step 3: Handle space selection (only if meeting exists)
  const handleSpaceSelection = (spaceId) => {
    // console.log("Selected Space ID:", spaceId);
    // if (!meetingExists) {
    //     alert("No active meeting found. Cannot select a space.");
    //     return;
    // }
    if (!meetingExists) {
      // Find latest past session across all rooms
      const allSessions = Object.values(enabledRoom).flat();
      const now = new Date();
      const pastSessions = allSessions
        .filter((session) => new Date(session.rawStartTime) < now)
        .sort((a, b) => new Date(b.rawStartTime) - new Date(a.rawStartTime));

      const latestPastSession = pastSessions[0];
      console.log(latestPastSession);

      if (!latestPastSession) {
        // alert("No session history found to save your selection.");
        return;
      }

      axios
        .post(`${Env.REACT_APP_PYTHON_API_URL}/api/select-space`, {
          PlutonicuserID: PlutonicuserID,
          selectedSpace: spaceId,
          meetingID: latestPastSession.meetingID, // Include the past meeting ID
        })
        .then(() => {
          setSelectedSpace(spaceId);
          // console.log("Space selection saved to latest past session.");
        })
        .catch((err) => console.error("Error updating space selection:", err));

      return;
    }

    if (selectedSpace === spaceId) {
      // console.log("Space is already selected. No API call needed.");
      return; // ✅ Avoid unnecessary API request
    }

    setSelectedSpace(spaceId);
    axios
      .post(`${Env.REACT_APP_PYTHON_API_URL}/api/select-space`, {
        PlutonicuserID: PlutonicuserID,
        selectedSpace: spaceId,
      })
      .then(() => console.log("Space selection updated"))
      .catch((err) => console.error("Error updating space selection:", err));
  };

  const rooms = [
    {
      id: "campsite",
      title: "Plutonic Therapy Campfire",
      description:
        "Unpack your thoughts with your licensed mental health professional next to the campfire. Trees swaying and crickets chirping while enjoying the beautiful night sky. ",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: campsite,
      available:
        enabledRoom["campsite"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["campsite"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["campsite"] || false,
      sessionStartTimeEST: sessionStartTimes["campsite"] || "",
    },
    {
      id: "mountain",
      title: "Plutonic Therapy Forest Office",
      description:
        "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: forest,
      // available: enabledRoom["mountain"]?.some((session) => session.isAvailable) || false,
      // selectable: false, // Cannot select "coming soon" rooms
      available:
        enabledRoom["mountain"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["mountain"]?.length > 0 ?? false, // Selectable if a meeting exists
      isComingSoon: false,
      online: roomsOnlineStatus["mountain"] || false,
      sessionStartTimeEST: sessionStartTimes["mountain"] || "",
    },
    {
      id: "beach",
      title: "Plutonic Therapy Beach Office",
      description:
        "Consider having a session with your licensed mental health professional inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset as you reduce stress.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: beach,
      // available: enabledRoom["beach"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["beach"]?.length > 0 ?? false, // Selectable if a meeting exists
      available:
        enabledRoom["beach"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["beach"] || false,
      sessionStartTimeEST: sessionStartTimes["beach"] || "",
    },
    {
      id: "park",
      title: "Plutonic Therapy Quiet Park",
      description:
        "Consider having a session with your licensed mental health professional while taking a walk around the park or while sitting on a park bench. This quiet park is a perfect safe space to talk.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: park,
      available:
        enabledRoom["park"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["park"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["park"] || false,
      sessionStartTimeEST: sessionStartTimes["park"] || "",
    },
    {
                  id: "winter-holiday",
                  title: "Plutonic Therapy Winter Cabin",
                  description:
                    "Step into a cozy winter lodge where soft snow falls outside and warm lantern lights fills the cabin. Settle into the gentle winter ambience.",
                  accessibility: "PC Web Browser | Chrome, Edge",
                  style: "Seasonal",
                  usage: "Seasonal",
                  image: winterHoliday,
                  available:
                    enabledRoom["winter-holiday"]?.some((session) => session.isAvailable) ||
                    false,
                  selectable: enabledRoom["winter-holiday"]?.length > 0 ?? false, // Selectable if a meeting exists
                  // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
                  isComingSoon: false,
                  online: roomsOnlineStatus["winter-holiday"] || false,
                  sessionStartTimeEST: sessionStartTimes["winter-holiday"] || "",
                },
  ];

  const handleEnterClick = (roomType, meetingID = null) => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");

    // Handle test rooms
    if (
      roomType === "test-beach" ||
      roomType === "test-park" ||
      roomType === "test-forest" ||
      roomType === "test-campsite"
    ) {
      const testMeetingID = `${roomType}-test-meeting-id`;
      sessionStorage.setItem("meetingID", testMeetingID);
      sessionStorage.setItem("userId", userId);

      const realRoomType =
        roomType === "test-beach"
          ? "beach"
          : roomType === "test-park"
          ? "park"
          : roomType === "test-forest"
          ? "forest"
          : roomType === "test-campsite"
          ? "campsite"
          : "";

      // console.log(`[TestPage] Navigating to Unity build for ${realRoomType} room`);
      navigate(`/unity-room/${realRoomType}`);
      return;
    }

    if (meetingID) {
      // Directly enter the selected session
      sessionStorage.setItem("meetingID", meetingID);
      sessionStorage.setItem("userId", userId);
      navigate(`/unity-room/${roomType}`);
      return;
    }

    // Otherwise fallback to finding an available session
    const roomSessions = enabledRoom[roomType];
    if (!roomSessions || roomSessions.length === 0) {
      // alert("Room is not enabled. Please wait or check your eligibility.");
      return;
    }

    const session = roomSessions.find((s) => s.isAvailable);
    if (!session) {
      // alert("No active session is available at this time.");
      return;
    }

    sessionStorage.setItem("meetingID", session.meetingID);
    sessionStorage.setItem("userId", userId);
    navigate(`/unity-room/${roomType}`);
  };

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <Navbar
      // setCurrentNickname={(nickname) => {
      //   setCurrentNickname(nickname);
      //   localStorage.setItem("currentNickname", nickname);
      // }}
      // currentNickname={currentNickname}
      // handleLogout={handleLogout}
      // setCurrentFormType={setCurrentFormType}
      // showButtons={true}
      // PlutonicuserID={
      //   PlutonicuserID || localStorage.getItem("PlutonicuserID")
      // }
      />
      <div
        className="relative flex flex-col items-center min-h-screen pt-24 pb-16 px-12 mx-auto"
        style={{
  background: "linear-gradient(to bottom, #61D8FF, #D7FFF6, #FFF9B8)",
}}
      >

      <div
  className="absolute inset-0 z-0 pointer-events-none overflow-hidden"
  style={{ isolation: "isolate" }}
>
    {/* ☀️ Sun */}
<img
  src={summerSun}
  alt="sun"
  className="absolute top-[13vh] right-[1vw] w-[225px] md:w-[225px] pointer-events-none select-none z-0 animate-[spin_120s_linear_infinite]"
/>

  {/* ☁️ Clouds */}
  <img
    src={summerCloudSet1}
    alt="clouds top left"
  className="absolute top-[12vh] left-[8vw] w-[480px] md:w-[460px] pointer-events-none select-none z-0"
  />

  <img
    src={summerCloudSet2}
    alt="clouds middle"
  className="absolute top-[10vh] left-[44%] w-[400px] md:w-[480px] pointer-events-none select-none z-0"
  />

  {/* 🕊 Birds */}
  <img
    src={summerBirdSet1}
    alt="birds left"
    className="absolute top-[38vh] left-[10vw] w-[140px] md:w-[180px] opacity-85 pointer-events-none select-none z-0"
  />

  <img
    src={summerBirdSet2}
    alt="birds right"
    className="absolute top-[21vh] right-[17vw] w-[150px] md:w-[190px] opacity-85 pointer-events-none select-none z-0"
  />

  {/* 🌊 Waves */}
  <img
    src={summerWaves}
    alt="waves footer"
    className="absolute bottom-0 left-0 w-full h-[28vh] md:h-[32vh] object-cover pointer-events-none select-none z-0"
  />
</div>

    
    <div className="relative z-10 w-full" style={{ transform: "translateZ(0)" }}>
        <h2 className="text-3xl font-bold mb-8 self-start pl-4 mt-8">
          Your Virtual Spaces
            <RefreshMeetingsButton onRefresh={refreshMeetings} refreshing={refreshing} />
        </h2>
          {refreshError && <p role="alert" className="text-red-600">{refreshError}</p>}
        <h2 className="text-xl font-bold mb-4 self-start pl-4 ">
          Select Your Preferred Session Space
        </h2>

        <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
          {rooms.map((room) => (
            <TherapyRoomCard
              key={room.id}
              room={room}
              isSelected={selectedSpace === room.id}
              onSelect={() => handleSpaceSelection(room.id)}
              onEnterClick={(meetingID) => handleEnterClick(room.id, meetingID)}
              sessions={enabledRoom[room.id] || []}
            />
          ))}
        </div>
        </div>
      </div>
      <WarningBanner/>
      <Footer />
      <SessionFeedbackModal
        isOpen={showSessionFeedback}
        onClose={() => setShowSessionFeedback(false)}
      />
    </div>
  );
}

export default ClientTherapyRooms;
